export default [
    {
        "Departamento": "Antioquia",
        "Municipio": "Medellín",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Abejorral",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Abriaquí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Alejandría",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Amagá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Amalfi",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Andes",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Angelópolis",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Angostura",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Anorí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Santa Fé de Antioquia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Anzá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Apartadó",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Arboletes",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Argelia",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Armenia",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Barbosa",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Belmira",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Bello",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Betania",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Betulia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Ciudad Bolívar",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Briceño",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Buriticá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Cáceres",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Caicedo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Caldas",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Campamento",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Cañasgordas",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Caracolí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Caramanta",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Carepa",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "El Carmen de Viboral",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Carolina",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Caucasia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Chigorodó",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Cisneros",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Cocorná",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Concepción",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Concordia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Copacabana",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Dabeiba",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Donmatías",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Ebéjico",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "El Bagre",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Entrerríos",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Envigado",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Fredonia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Frontino",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Giraldo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Girardota",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Gómez Plata",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Granada",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Guadalupe",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Guarne",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Guatapé",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Heliconia",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Hispania",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Itagüí",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Ituango",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Jardín",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Jericó",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "La Ceja",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "La Estrella",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "La Pintada",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "La Unión",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Liborina",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Maceo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Marinilla",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Montebello",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Murindó",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Mutatá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Nariño",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Necoclí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Nechí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Olaya",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Peñol",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Peque",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Pueblorrico",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Puerto Berrío",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Puerto Nare",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Puerto Triunfo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Remedios",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Retiro",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Rionegro",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Sabanalarga",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Sabaneta",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Salgar",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "San Andrés de Cuerquía",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "San Carlos",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "San Francisco",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "San Jerónimo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "San José de La Montaña",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "San Juan de Urabá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "San Luis",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "San Pedro de Los Milagros",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "San Pedro de Urabá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "San Rafael",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "San Roque",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "San Vicente Ferrer",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Santa Bárbara",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Santa Rosa de Osos",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Santo Domingo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "El Santuario",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Segovia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Sonsón",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Sopetrán",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Támesis",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Tarazá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Tarso",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Titiribí",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Toledo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Turbo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Uramita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Urrao",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Valdivia",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Valparaíso",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Vegachí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Venecia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Vigía del Fuerte",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Yalí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Yarumal",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Yolombó",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Yondó",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Antioquia",
        "Municipio": "Zaragoza",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Barranquilla",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Baranoa",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Campo de La Cruz",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Candelaria",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Galapa",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Juan de Acosta",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Luruaco",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Malambo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Manatí",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Palmar de Varela",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Piojó",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Polonuevo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Ponedera",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Puerto Colombia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Repelón",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Sabanagrande",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Sabanalarga",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Santa Lucía",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Santo Tomás",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Soledad",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Suan",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Tubará",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Atlántico",
        "Municipio": "Usiacurí",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bogotá, D.C.",
        "Municipio": "Bogotá, D.C.",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Cartagena de Indias",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Achí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Altos del Rosario",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Arenal",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Arjona",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Arroyohondo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Barranco de Loba",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Calamar",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Cantagallo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Cicuco",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Córdoba",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Clemencia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "El Carmen de Bolívar",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "El Guamo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "El Peñón",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Hatillo de Loba",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Magangué",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Mahates",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Margarita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "María La Baja",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Montecristo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Mompós",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Morales",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Norosí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Pinillos",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Regidor",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Río Viejo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "San Cristóbal",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "San Estanislao",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "San Fernando",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "San Jacinto",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "San Jacinto del Cauca",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "San Juan Nepomuceno",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "San Martín de Loba",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "San Pablo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Santa Catalina",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Santa Rosa",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Santa Rosa del Sur",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Simití",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Soplaviento",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Talaigua Nuevo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Tiquisio",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Turbaco",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Turbaná",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Villanueva",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Bolívar",
        "Municipio": "Zambrano",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Tunja",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Almeida",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Aquitania",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Arcabuco",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Belén",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Berbeo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Betéitiva",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Boavita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Boyacá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Briceño",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Buenavista",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Busbanzá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Caldas",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Campohermoso",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Cerinza",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Chinavita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Chiquinquirá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Chiscas",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Chita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Chitaraque",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Chivatá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Ciénega",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Cómbita",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Coper",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Corrales",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Covarachía",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Cubará",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Cucaita",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Cuítiva",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Chíquiza",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Chivor",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Duitama",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "El Cocuy",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "El Espino",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Firavitoba",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Floresta",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Gachantivá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Gámeza",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Garagoa",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Guacamayas",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Guateque",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Guayatá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Güicán de La Sierra",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Iza",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Jenesano",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Jericó",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Labranzagrande",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "La Capilla",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "La Victoria",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "La Uvita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Villa de Leyva",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Macanal",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Maripí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Miraflores",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Mongua",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Monguí",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Moniquirá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Motavita",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Muzo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Nobsa",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Nuevo Colón",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Oicatá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Otanche",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Pachavita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Páez",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Paipa",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Pajarito",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Panqueba",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Pauna",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Paya",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Paz de Río",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Pesca",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Pisba",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Puerto Boyacá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Quípama",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Ramiriquí",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Ráquira",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Rondón",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Saboyá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Sáchica",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Samacá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "San Eduardo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "San José de Pare",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "San Luis de Gaceno",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "San Mateo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "San Miguel de Sema",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "San Pablo de Borbur",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Santana",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Santa María",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Santa Rosa de Viterbo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Santa Sofía",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Sativanorte",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Sativasur",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Siachoque",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Soatá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Socotá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Socha",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Sogamoso",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Somondoco",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Sora",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Sotaquirá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Soracá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Susacón",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Sutamarchán",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Sutatenza",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Tasco",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Tenza",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Tibaná",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Tibasosa",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Tinjacá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Tipacoque",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Toca",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Togüí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Tópaga",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Tota",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Tununguá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Turmequé",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Tuta",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Tutazá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Úmbita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Ventaquemada",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Viracachá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Boyacá",
        "Municipio": "Zetaquira",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Manizales",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Aguadas",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Anserma",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Aranzazu",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Belalcázar",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Chinchiná",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Filadelfia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "La Dorada",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "La Merced",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Manzanares",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Marmato",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Marquetalia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Marulanda",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Neira",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Norcasia",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Pácora",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Palestina",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Pensilvania",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Riosucio",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Risaralda",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Salamina",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Samaná",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "San José",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Supía",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Victoria",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Villamaría",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caldas",
        "Municipio": "Viterbo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caquetá",
        "Municipio": "Florencia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Caquetá",
        "Municipio": "Albania",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caquetá",
        "Municipio": "Belén de Los Andaquíes",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caquetá",
        "Municipio": "Cartagena del Chairá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caquetá",
        "Municipio": "Curillo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caquetá",
        "Municipio": "El Doncello",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caquetá",
        "Municipio": "El Paujíl",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caquetá",
        "Municipio": "La Montañita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caquetá",
        "Municipio": "Milán",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caquetá",
        "Municipio": "Morelia",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caquetá",
        "Municipio": "Puerto Rico",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caquetá",
        "Municipio": "San José del Fragua",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caquetá",
        "Municipio": "San Vicente del Caguán",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caquetá",
        "Municipio": "Solano",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caquetá",
        "Municipio": "Solita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Caquetá",
        "Municipio": "Valparaíso",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Popayán",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Almaguer",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Argelia",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Balboa",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Bolívar",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Buenos Aires",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Cajibío",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Caldono",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Caloto",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Corinto",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "El Tambo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Florencia",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Guachené",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Guapí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Inzá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Jambaló",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "La Sierra",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "La Vega",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "López de Micay",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Mercaderes",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Miranda",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Morales",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Padilla",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Páez",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Patía",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Piamonte",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Piendamó - Tunía",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Puerto Tejada",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Puracé",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Rosas",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "San Sebastián",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Santander de Quilichao",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Santa Rosa",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Silvia",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Sotara",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Suárez",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Sucre",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Timbío",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Timbiquí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Toribío",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Totoró",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cauca",
        "Municipio": "Villa Rica",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "Valledupar",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "Aguachica",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "Agustín Codazzi",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "Astrea",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "Becerril",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "Bosconia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "Chimichagua",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "Chiriguaná",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "Curumaní",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "El Copey",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "El Paso",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "Gamarra",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "González",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "La Gloria",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "La Jagua de Ibirico",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "Manaure Balcón del Cesar",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "Pailitas",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "Pelaya",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "Pueblo Bello",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "Río de Oro",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "La Paz",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "San Alberto",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "San Diego",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "San Martín",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cesar",
        "Municipio": "Tamalameque",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Montería",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Ayapel",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Buenavista",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Canalete",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Cereté",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Chimá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Chinú",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Ciénaga de Oro",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Cotorra",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "La Apartada",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Lorica",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Los Córdobas",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Momil",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Montelíbano",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Moñitos",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Planeta Rica",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Pueblo Nuevo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Puerto Escondido",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Puerto Libertador",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Purísima de La Concepción",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Sahagún",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "San Andrés de Sotavento",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "San Antero",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "San Bernardo del Viento",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "San Carlos",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "San José de Uré",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "San Pelayo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Tierralta",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Tuchín",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Córdoba",
        "Municipio": "Valencia",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Agua de Dios",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Albán",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Anapoima",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Anolaima",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Arbeláez",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Beltrán",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Bituima",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Bojacá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Cabrera",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Cachipay",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Cajicá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Caparrapí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Cáqueza",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Carmen de Carupa",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Chaguaní",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Chía",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Chipaque",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Choachí",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Chocontá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Cogua",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Cota",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Cucunubá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "El Colegio",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "El Peñón",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "El Rosal",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Facatativá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Fómeque",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Fosca",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Funza",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Fúquene",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Fusagasugá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Gachalá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Gachancipá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Gachetá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Gama",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Girardot",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Granada",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Guachetá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Guaduas",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Guasca",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Guataquí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Guatavita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Guayabal de Síquima",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Guayabetal",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Gutiérrez",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Jerusalén",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Junín",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "La Calera",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "La Mesa",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "La Palma",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "La Peña",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "La Vega",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Lenguazaque",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Machetá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Madrid",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Manta",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Medina",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Mosquera",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Nariño",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Nemocón",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Nilo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Nimaima",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Nocaima",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Venecia",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Pacho",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Paime",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Pandi",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Paratebueno",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Pasca",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Puerto Salgar",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Pulí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Quebradanegra",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Quetame",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Quipile",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Apulo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Ricaurte",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "San Antonio del Tequendama",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "San Bernardo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "San Cayetano",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "San Francisco",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "San Juan de Rioseco",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Sasaima",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Sesquilé",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Sibaté",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Silvania",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Simijaca",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Soacha",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Sopó",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Subachoque",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Suesca",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Supatá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Susa",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Sutatausa",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Tabio",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Tausa",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Tena",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Tenjo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Tibacuy",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Tibirita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Tocaima",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Tocancipá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Topaipí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Ubalá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Ubaque",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Villa de San Diego de Ubaté",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Une",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Útica",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Vergara",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Vianí",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Villagómez",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Villapinzón",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Villeta",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Viotá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Yacopí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Zipacón",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Cundinamarca",
        "Municipio": "Zipaquirá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Quibdó",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Acandí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Alto Baudó",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Atrato",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Bagadó",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Bahía Solano",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Bajo Baudó",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Bojayá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "El Cantón del San Pablo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Carmen del Darién",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Cértegui",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Condoto",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "El Carmen de Atrato",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "El Litoral del San Juan",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Istmina",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Juradó",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Lloró",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Medio Atrato",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Medio Baudó",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Medio San Juan",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Nóvita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Nuquí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Río Iró",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Río Quito",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Riosucio",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "San José del Palmar",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Sipí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Tadó",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Unguía",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Chocó",
        "Municipio": "Unión Panamericana",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Neiva",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Acevedo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Agrado",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Aipe",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Algeciras",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Altamira",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Baraya",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Campoalegre",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Colombia",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Elías",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Garzón",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Gigante",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Guadalupe",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Hobo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Íquira",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Isnos",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "La Argentina",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "La Plata",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Nátaga",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Oporapa",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Paicol",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Palermo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Palestina",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Pital",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Pitalito",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Rivera",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Saladoblanco",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "San Agustín",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Santa María",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Suaza",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Tarqui",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Tesalia",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Tello",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Teruel",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Timaná",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Villavieja",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Huila",
        "Municipio": "Yaguará",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "La Guajira",
        "Municipio": "Riohacha",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "La Guajira",
        "Municipio": "Albania",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "La Guajira",
        "Municipio": "Barrancas",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "La Guajira",
        "Municipio": "Dibulla",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "La Guajira",
        "Municipio": "Distracción",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "La Guajira",
        "Municipio": "El Molino",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "La Guajira",
        "Municipio": "Fonseca",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "La Guajira",
        "Municipio": "Hatonuevo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "La Guajira",
        "Municipio": "La Jagua del Pilar",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "La Guajira",
        "Municipio": "Maicao",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "La Guajira",
        "Municipio": "Manaure",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "La Guajira",
        "Municipio": "San Juan del Cesar",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "La Guajira",
        "Municipio": "Uribia",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "La Guajira",
        "Municipio": "Urumita",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "La Guajira",
        "Municipio": "Villanueva",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Santa Marta",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Algarrobo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Aracataca",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Ariguaní",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Cerro de San Antonio",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Chivolo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Ciénaga",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Concordia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "El Banco",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "El Piñón",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "El Retén",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Fundación",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Guamal",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Nueva Granada",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Pedraza",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Pijiño del Carmen",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Pivijay",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Plato",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Puebloviejo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Remolino",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Sabanas de San Ángel",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Salamina",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "San Sebastián de Buenavista",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "San Zenón",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Santa Ana",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Santa Bárbara de Pinto",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Sitionuevo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Tenerife",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Zapayán",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Magdalena",
        "Municipio": "Zona Bananera",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Villavicencio",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Acacías",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Barranca de Upía",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Cabuyaro",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Castilla La Nueva",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Cubarral",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Cumaral",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "El Calvario",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "El Castillo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "El Dorado",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Fuente de Oro",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Granada",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Guamal",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Mapiripán",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Mesetas",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "La Macarena",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Uribe",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Lejanías",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Puerto Concordia",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Puerto Gaitán",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Puerto López",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Puerto Lleras",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Puerto Rico",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Restrepo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Meta",
        "Municipio": "San Carlos de Guaroa",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "San Juan de Arama",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "San Juanito",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "San Martín",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Meta",
        "Municipio": "Vistahermosa",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Pasto",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Albán",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Aldana",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Ancuyá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Arboleda",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Barbacoas",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Belén",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Buesaco",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Colón",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Consacá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Contadero",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Córdoba",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Cuaspúd",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Cumbal",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Cumbitara",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Chachagüí",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "El Charco",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "El Peñol",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "El Rosario",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "El Tablón de Gómez",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "El Tambo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Funes",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Guachucal",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Guaitarilla",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Gualmatán",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Iles",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Imués",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Ipiales",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "La Cruz",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "La Florida",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "La Llanada",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "La Tola",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "La Unión",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Leiva",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Linares",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Los Andes",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Magüí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Mallama",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Mosquera",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Nariño",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Olaya Herrera",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Ospina",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Francisco Pizarro",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Policarpa",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Potosí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Providencia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Puerres",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Pupiales",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Ricaurte",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Roberto Payán",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Samaniego",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Sandoná",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "San Bernardo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "San Lorenzo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "San Pablo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "San Pedro de Cartago",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Santa Bárbara",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Santacruz",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Sapuyes",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Taminango",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Tangua",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "San Andrés de Tumaco",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Túquerres",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Nariño",
        "Municipio": "Yacuanquer",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "San José de Cúcuta",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Ábrego",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Arboledas",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Bochalema",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Bucarasica",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Cácota",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Cáchira",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Chinácota",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Chitagá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Convención",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Cucutilla",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Durania",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "El Carmen",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "El Tarra",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "El Zulia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Gramalote",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Hacarí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Herrán",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Labateca",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "La Esperanza",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "La Playa",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Los Patios",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Lourdes",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Mutiscua",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Ocaña",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Pamplona",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Pamplonita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Puerto Santander",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Ragonvalia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Salazar",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "San Calixto",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "San Cayetano",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Santiago",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Sardinata",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Silos",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Teorama",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Tibú",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Toledo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Villa Caro",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Norte de Santander",
        "Municipio": "Villa del Rosario",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Quindio",
        "Municipio": "Armenia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Quindio",
        "Municipio": "Buenavista",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Quindio",
        "Municipio": "Calarcá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Quindio",
        "Municipio": "Circasia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Quindio",
        "Municipio": "Córdoba",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Quindio",
        "Municipio": "Filandia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Quindio",
        "Municipio": "Génova",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Quindio",
        "Municipio": "La Tebaida",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Quindio",
        "Municipio": "Montenegro",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Quindio",
        "Municipio": "Pijao",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Quindio",
        "Municipio": "Quimbaya",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Quindio",
        "Municipio": "Salento",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Risaralda",
        "Municipio": "Pereira",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Risaralda",
        "Municipio": "Apía",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Risaralda",
        "Municipio": "Balboa",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Risaralda",
        "Municipio": "Belén de Umbría",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Risaralda",
        "Municipio": "Dosquebradas",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Risaralda",
        "Municipio": "Guática",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Risaralda",
        "Municipio": "La Celia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Risaralda",
        "Municipio": "La Virginia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Risaralda",
        "Municipio": "Marsella",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Risaralda",
        "Municipio": "Mistrató",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Risaralda",
        "Municipio": "Pueblo Rico",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Risaralda",
        "Municipio": "Quinchía",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Risaralda",
        "Municipio": "Santa Rosa de Cabal",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Risaralda",
        "Municipio": "Santuario",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Bucaramanga",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Aguada",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Albania",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Aratoca",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Barbosa",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Barichara",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Barrancabermeja",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Betulia",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Bolívar",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Cabrera",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "California",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Capitanejo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Carcasí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Cepitá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Cerrito",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Charalá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Charta",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Chima",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Chipatá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Cimitarra",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Concepción",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Confines",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Contratación",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Coromoro",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Curití",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "El Carmen de Chucurí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "El Guacamayo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "El Peñón",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "El Playón",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Encino",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Enciso",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Florián",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Floridablanca",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Galán",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Gámbita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Girón",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Guaca",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Guadalupe",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Guapotá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Guavatá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Güepsa",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Hato",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Jesús María",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Jordán",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "La Belleza",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Landázuri",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "La Paz",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Lebrija",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Los Santos",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Macaravita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Málaga",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Matanza",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Mogotes",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Molagavita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Ocamonte",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Oiba",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Onzaga",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Palmar",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Palmas del Socorro",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Páramo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Piedecuesta",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Pinchote",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Puente Nacional",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Puerto Parra",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Puerto Wilches",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Rionegro",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Sabana de Torres",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "San Andrés",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "San Benito",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "San Gil",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "San Joaquín",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "San José de Miranda",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "San Miguel",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "San Vicente de Chucurí",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Santa Bárbara",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Santa Helena del Opón",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Simacota",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Socorro",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Suaita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Sucre",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Suratá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Tona",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Valle de San José",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Vélez",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Vetas",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Villanueva",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Santander",
        "Municipio": "Zapatoca",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "Sincelejo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "Buenavista",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "Caimito",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "Colosó",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "Corozal",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "Coveñas",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "Chalán",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "El Roble",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "Galeras",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "Guaranda",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "La Unión",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "Los Palmitos",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "Majagual",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "Morroa",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "Ovejas",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "Palmito",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "Sampués",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "San Benito Abad",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "San Juan de Betulia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "San Marcos",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "San Onofre",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "San Pedro",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "San Luis de Sincé",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "Sucre",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "Santiago de Tolú",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Sucre",
        "Municipio": "Tolú Viejo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Ibagué",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Alpujarra",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Alvarado",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Ambalema",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Anzoátegui",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Armero",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Ataco",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Cajamarca",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Carmen de Apicalá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Casabianca",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Chaparral",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Coello",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Coyaima",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Cunday",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Dolores",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Espinal",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Falan",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Flandes",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Fresno",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Guamo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Herveo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Honda",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Icononzo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Lérida",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Líbano",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "San Sebastián de Mariquita",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Melgar",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Murillo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Natagaima",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Ortega",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Palocabildo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Piedras",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Planadas",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Prado",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Purificación",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Rioblanco",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Roncesvalles",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Rovira",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Saldaña",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "San Antonio",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "San Luis",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Santa Isabel",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Suárez",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Valle de San Juan",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Venadillo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Villahermosa",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Tolima",
        "Municipio": "Villarrica",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Cali",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Alcalá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Andalucía",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Ansermanuevo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Argelia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Bolívar",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Buenaventura",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Guadalajara de Buga",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Bugalagrande",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Caicedonia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Calima",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Candelaria",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Cartago",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Dagua",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "El Águila",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "El Cairo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "El Cerrito",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "El Dovio",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Florida",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Ginebra",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Guacarí",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Jamundí",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "La Cumbre",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "La Unión",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "La Victoria",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Obando",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Palmira",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Pradera",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Restrepo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Riofrío",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Roldanillo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "San Pedro",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Sevilla",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Toro",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Trujillo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Tuluá",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Ulloa",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Versalles",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Vijes",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Yotoco",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Yumbo",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Valle del Cauca",
        "Municipio": "Zarzal",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Arauca",
        "Municipio": "Arauca",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Arauca",
        "Municipio": "Arauquita",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Arauca",
        "Municipio": "Cravo Norte",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Arauca",
        "Municipio": "Fortul",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Arauca",
        "Municipio": "Puerto Rondón",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Arauca",
        "Municipio": "Saravena",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Arauca",
        "Municipio": "Tame",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "Yopal",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "Aguazul",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "Chámeza",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "Hato Corozal",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "La Salina",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "Maní",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "Monterrey",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "Nunchía",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "Orocué",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "Paz de Ariporo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "Pore",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "Recetor",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "Sabanalarga",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "Sácama",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "San Luis de Palenque",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "Támara",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "Tauramena",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "Trinidad",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Casanare",
        "Municipio": "Villanueva",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Putumayo",
        "Municipio": "Mocoa",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Putumayo",
        "Municipio": "Colón",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Putumayo",
        "Municipio": "Orito",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Putumayo",
        "Municipio": "Puerto Asís",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Putumayo",
        "Municipio": "Puerto Caicedo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Putumayo",
        "Municipio": "Puerto Guzmán",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Putumayo",
        "Municipio": "Puerto Leguízamo",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Putumayo",
        "Municipio": "Sibundoy",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Putumayo",
        "Municipio": "San Francisco",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Putumayo",
        "Municipio": "San Miguel",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Putumayo",
        "Municipio": "Santiago",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Putumayo",
        "Municipio": "Valle del Guamuez",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Putumayo",
        "Municipio": "Villagarzón",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Archipiélago de San Andrés, Providencia y Santa Catalina",
        "Municipio": "San Andrés",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Archipiélago de San Andrés, Providencia y Santa Catalina",
        "Municipio": "Providencia",
        "Modalidad": "Urbano"
    },
    {
        "Departamento": "Amazonas",
        "Municipio": "Leticia",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Amazonas",
        "Municipio": "El Encanto",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Amazonas",
        "Municipio": "La Chorrera",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Amazonas",
        "Municipio": "La Pedrera",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Amazonas",
        "Municipio": "La Victoria",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Amazonas",
        "Municipio": "Mirití - Paraná",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Amazonas",
        "Municipio": "Puerto Alegría",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Amazonas",
        "Municipio": "Puerto Arica",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Amazonas",
        "Municipio": "Puerto Nariño",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Amazonas",
        "Municipio": "Puerto Santander",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Amazonas",
        "Municipio": "Tarapacá",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Guainía",
        "Municipio": "Inírida",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Guainía",
        "Municipio": "Barrancominas",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Guainía",
        "Municipio": "San Felipe",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Guainía",
        "Municipio": "Puerto Colombia",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Guainía",
        "Municipio": "La Guadalupe",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Guainía",
        "Municipio": "Cacahual",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Guainía",
        "Municipio": "Pana Pana",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Guainía",
        "Municipio": "Morichal",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Guaviare",
        "Municipio": "San José del Guaviare",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Guaviare",
        "Municipio": "Calamar",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Guaviare",
        "Municipio": "El Retorno",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Guaviare",
        "Municipio": "Miraflores",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Vaupés",
        "Municipio": "Mitú",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Vaupés",
        "Municipio": "Carurú",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Vaupés",
        "Municipio": "Pacoa",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Vaupés",
        "Municipio": "Taraira",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Vaupés",
        "Municipio": "Papunahua",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Vaupés",
        "Municipio": "Yavaraté",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Vichada",
        "Municipio": "Puerto Carreño",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Vichada",
        "Municipio": "La Primavera",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Vichada",
        "Municipio": "Santa Rosalía",
        "Modalidad": "Rural"
    },
    {
        "Departamento": "Vichada",
        "Municipio": "Cumaribo",
        "Modalidad": "Rural"
    }
]